import { render, staticRenderFns } from "./сSocTape.vue?vue&type=template&id=e97b27e6&scoped=true&"
import script from "./сSocTape.vue?vue&type=script&lang=js&"
export * from "./сSocTape.vue?vue&type=script&lang=js&"
import style0 from "./сSocTape.vue?vue&type=style&index=0&id=e97b27e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97b27e6",
  null
  
)

export default component.exports